// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"1466":"SportPage","5987":"CasinoPage"}[chunkId] || chunkId) + "." + {"1466":"9bcfaf3d","5987":"a7d110c4","7507":"0ed712ff"}[chunkId] + ".chunk.css";
};